// src/components/FrozenVersion.js
//
// RULING 72.2 / 72.3 item 2 (Record 583): the officer who returned a claim keeps the FROZEN COPY taken at the
// return - read-only, stamped SUPERSEDED (ISS-46 section 46.7: "never VOID - it was true when served"). The live
// claim is now the member's draft and beyond the officer (ruling 56); this is the version he already held.
// Reads claims/{claimId}/versions/r{returnCount}, written in the same batch as the return (firestore.rules).
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { frozenVersionId, frozenFields } from '../data/claimReturn';

export default function FrozenVersion({ claimId, returnCount, onClose }) {
  const [v, setV] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    let live = true;
    getDoc(doc(db, 'claims', claimId, 'versions', frozenVersionId(returnCount)))
      .then(s => { if (!live) return; if (s.exists()) setV(s.data()); else setErr('No frozen copy is on record for this return (returns made before 2026-10-07 took none).'); })
      .catch(e => { if (live) setErr('The frozen copy could not be read: ' + ((e && e.message) || 'refused')); });
    return () => { live = false; };
  }, [claimId, returnCount]);
  const box = { position: 'relative', background: '#0D1B2A', border: '1px solid #2E4A6B', borderRadius: 8, padding: '12px 16px', margin: '6px 0 10px', fontSize: 12, color: '#DCE7F2' };
  const stamp = { position: 'absolute', top: 10, right: 14, border: '3px solid #C0392B', color: '#C0392B', fontWeight: 800, letterSpacing: 2, padding: '2px 10px', transform: 'rotate(-6deg)', fontSize: 14 };
  return (
    <div style={box}>
      <span style={stamp}>SUPERSEDED</span>
      <div style={{ fontWeight: 700, marginBottom: 6 }}>Frozen copy taken when you returned it (read-only)</div>
      {err ? <div style={{ color: '#E67E22' }}>{err}</div> : !v ? <div>Reading...</div> : (
        <div>
          <div style={{ color: '#8AA4BF', marginBottom: 8 }}>
            Frozen {v.frozenAt && v.frozenAt.toDate ? v.frozenAt.toDate().toISOString().slice(0, 16).replace('T', ' ') + 'Z' : ''}
            {' '}at status "{v.statusAtFreeze}" - trip {v.returnCount}. It was the operative version when it was served;
            the member now holds the working copy.
          </div>
          {frozenFields(v.snapshot).map(([k, val]) => (
            <div key={k} style={{ display: 'flex', gap: 10, padding: '2px 0', borderBottom: '1px dotted #1E3550' }}>
              <span style={{ minWidth: 170, color: '#8AA4BF' }}>{k}</span>
              <span style={{ whiteSpace: 'pre-wrap' }}>{val}</span>
            </div>
          ))}
        </div>
      )}
      {onClose ? <button className="btn btn-secondary" style={{ fontSize: 11, marginTop: 8, padding: '3px 10px' }} onClick={onClose}>Close</button> : null}
    </div>
  );
}
